import { LogOut } from 'lucide-react';
import { useAppStore, useAuthStore, useTrackingStore } from 'store';
import { Button } from 'components/ui/Button';
import { CardHeader } from 'components/ui/card';
import { SCREEN_TYPES } from 'utils/constants';
import { resetAllProductRelatedStores } from '../utils';

export default function AppHeader() {
  const { user, stationId, logout } = useAuthStore();
  const { currentScreen, setCurrentScreen } = useAppStore();
  const { setCurrentTrackingId } = useTrackingStore();

  const userDisplay = user?.name || user?.email || user?.id || '';
  const showExitButton =
    currentScreen !== SCREEN_TYPES.APP_SELECT && currentScreen !== SCREEN_TYPES.LOGIN;
  const onExitClick = () => {
    setCurrentScreen(SCREEN_TYPES.APP_SELECT);
    resetAllProductRelatedStores();
    setCurrentTrackingId('');
  };

  return (
    <CardHeader className="flex-row items-center justify-between gap-3 space-y-0 pb-4">
      <div className="min-w-0 flex-1">
        <div className="truncate text-base font-semibold text-slate-800">{userDisplay}</div>
        <div className="mt-1 text-sm text-slate-500">Station {stationId || ''}</div>
      </div>
      {showExitButton && <Button onClick={onExitClick}>Exit </Button>}

      <Button
        onClick={() => {
          void logout();
        }}
        variant="destructive"
        size="sm"
        className="h-10 rounded-xl px-4"
      >
        <LogOut className="h-4 w-4" />
        Logout
      </Button>
    </CardHeader>
  );
}
